wbApp.controller('StudentsCoursesCtrl', ['$scope', '$modal', '$translate', '$q', 'courseSvc', 'courseRegistrationSvc', 'tenantSettingSvc', 
function ($scope, $modal, $translate, $q, courseSvc, courseRegistrationSvc, tenantSettingSvc) {

    $scope.tenantSettings = tenantSettingSvc.settings;

    let selectedStudent = null;
    let isActive = true;
    let loaded = false;
    $scope.courseRegistrations = [];

    $scope.$on('studentSelectionChanged', function (e, data) {
        if (data.student) {
            if (isActive) {
                if (selectedStudent !== data.student || data.refresh) {
                    $scope.courseRegistrations = courseRegistrationSvc.getAllCoursesByStudent(data.student.id);
                }
                loaded = true;
            } else {
                loaded = false;
            }
        } else {
            $scope.courseRegistrations.length = 0;
        }
        selectedStudent = data.student;
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 1) {
            if (!isActive) {
                isActive = true;
                if (!loaded && selectedStudent) {
                    $scope.courseRegistrations = courseRegistrationSvc.getAllCoursesByStudent(selectedStudent.id);
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
    });

    $scope.filterOptions = {
        filterText: ""
    };

    $scope.courseRegistrationsGridSettings = {
        name: 'courseRegistrations',
        keyExpr: 'courseRegistrationID',
        columns: [
            {
                dataField: 'semesterName',
                caption: $translate.instant('TXT_LBL_SEMESTER'),
                dataType: 'string',
                width: '140px',
                sortOrder: 'desc',
                sortIndex: 0,
                calculateSortValue: function (data) {
                    return data.semesterID;
                }
            },
            { dataField: 'courseFullName', caption: $translate.instant("TXT_LBL_COURSE"), dataType: 'string', width: '300px' },
            { dataField: 'firstDate', caption: $translate.instant("TXT_MENU_SCHEDULE"), dataType: 'date', format: { raw: "EEE HH:mm" }, width: '80px' },
            { dataField: 'notes', caption: $translate.instant('TXT_NOTE'), dataType: 'string' },
            { dataField: 'price', caption: $translate.instant('TXT_LBL_PRICE'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
            { dataField: 'paymentsSum', caption: $translate.instant('TXT_LBL_PAYMENTS'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
            { dataField: 'registrationDate', caption: $translate.instant('TXT_SEC_CLIENT_COURSE_REGISTRATION'), dataType: 'date', format: { date: 'short' }, width: '80px', sortOrder: 'desc', sortIndex: 1, },
        ],
    };

    // if ($scope.tenantSettings.showArrearInsteadOfPayments) {
    //     $scope.gridOptions.columnDefs[4].field = 'arrear';
    //     $scope.gridOptions.columnDefs[4].displayName = 'TXT_LBL_ARREAR';
    // }

    if ($scope.tenantSettings.showArrearInsteadOfPayments) {
        let column = _.find($scope.courseRegistrationsGridSettings.columns, { dataField: 'paymentsSum' });
        if (column) {
            column.dataField = 'arrear';
            column.caption = $translate.instant('TXT_LBL_ARREAR')
        }
    }

    $scope.onRowEdit = function (model) {

        $q.all([
            detailDialogPromise.$promise, 
            courseRegistrationSvc.getByRegistrationId(model.courseRegistrationID).$promise,
            courseSvc.getByCourseID(model.courseID).$promise])
            .then(function (data) {
                detailDialogPromise.$scope.course = data[2];
                detailDialogPromise.$scope.model = new webooker_courses_models.CourseRegistration(data[1]);
                detailDialogPromise.$scope.onAfterSuccessSave = function () {
                    $scope.courseRegistrations = courseRegistrationSvc.getAllCoursesByStudent(selectedStudent.id);
                }
                detailDialogPromise.show();
            });
    }

    let detailDialogPromise = $modal({
        templateUrl: 'courses/courses/courses-detail-tabs/students-detail.html',
        show: false,
        scope: $scope.$new()
    });

}]);


